import { normalizeForSearch } from './format';

/**
 * Lọc ô chọn có tìm kiếm (`filterOption` của Ant Design): KHÔNG phân biệt dấu, hoa thường — gõ «thuong» hay
 * «Thương» đều ra «Trần Thị Thu Thương»; gõ nhiều từ thì cần đủ các từ, thứ tự nào cũng được. Tìm trong
 * `search` của lựa chọn nếu có (tên + tên đăng nhập…), không thì trong `label` (phải là chữ).
 */
export function selectOptionMatches(
  typed: string,
  option?: { label?: unknown; search?: unknown },
): boolean {
  const haystack = normalizeForSearch(String(option?.search ?? option?.label ?? ''));
  return normalizeForSearch(typed)
    .split(/\s+/)
    .filter(Boolean)
    .every((word) => haystack.includes(word));
}
